import { useEffect, useState } from "react";
import { fetchListings } from "../api/listings";
import { Link } from "react-router-dom";

export default function ListingsList() {
    const [listings, setListings] = useState([]);

    useEffect(() => {
        fetchListings().then(setListings);
    }, []);

    return (
        <div className="listings-grid">
            {listings.map((listing) => (
                <Link
                    key={listing.id}
                    to={`/listing/${listing.id}`}
                    className="listing-card"
                    style={{ textDecoration: "none", color: "inherit" }}
                >
                    <img src={listing.imageUrl} alt={listing.title} />
                    <h4>{listing.title}</h4>
                </Link>
            ))}
        </div>
    );
}